import { render, staticRenderFns } from "./step-micepec-recrods.vue?vue&type=template&id=11e6dc4a"
import script from "./step-micepec-recrods.vue?vue&type=script&lang=js"
export * from "./step-micepec-recrods.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports